import { render, staticRenderFns } from "./CustomMailPreview.vue?vue&type=template&id=80adac64&"
import script from "./CustomMailPreview.vue?vue&type=script&lang=js&"
export * from "./CustomMailPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports